import { render, staticRenderFns } from "./HomeCover.vue?vue&type=template&id=a10978bc&"
import script from "./HomeCover.vue?vue&type=script&lang=js&"
export * from "./HomeCover.vue?vue&type=script&lang=js&"
import style0 from "./HomeCover.vue?vue&type=style&index=0&id=a10978bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports